var $gcYvX$react = require("react");
var $gcYvX$reactjsxruntime = require("react/jsx-runtime");
var $gcYvX$styledcomponents = require("styled-components");
var $gcYvX$muimaterialGrid = require("@mui/material/Grid");
var $gcYvX$muimaterial = require("@mui/material");
var $gcYvX$muimaterialuseMediaQuery = require("@mui/material/useMediaQuery");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Loader", {
    enumerable: true,
    get: function get() {
        return $5052ded2deae85fc$exports.Loader;
    }
});
var $5052ded2deae85fc$exports = {};
"use strict";
Object.defineProperty($5052ded2deae85fc$exports, "__esModule", {
    value: true
});
$5052ded2deae85fc$exports.Loader = void 0;
var $cc328f81773e9021$exports = {};
"use strict";
function $cc328f81773e9021$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cc328f81773e9021$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cc328f81773e9021$var$_typeof(o);
}
Object.defineProperty($cc328f81773e9021$exports, "__esModule", {
    value: true
});
$cc328f81773e9021$exports.Grid = void 0;

var $cc328f81773e9021$var$_react = $cc328f81773e9021$var$_interopRequireDefault($gcYvX$react);

var $cc328f81773e9021$var$_styledComponents = $cc328f81773e9021$var$_interopRequireDefault($gcYvX$styledcomponents);

var $cc328f81773e9021$var$_Grid = $cc328f81773e9021$var$_interopRequireDefault($gcYvX$muimaterialGrid);

var $cc328f81773e9021$var$_excluded = [
    "inline",
    "spacing",
    "spacingTop",
    "spacingLeft",
    "spacingRight",
    "spacingBottom",
    "xsSpacing",
    "xsSpacingTop",
    "xsSpacingLeft",
    "xsSpacingRight",
    "xsSpacingBottom",
    "mdSpacing",
    "mdSpacingTop",
    "mdSpacingLeft",
    "mdSpacingRight",
    "mdSpacingBottom",
    "mdUpSpacing",
    "mdUpSpacingTop",
    "mdUpSpacingLeft",
    "mdUpSpacingRight",
    "mdUpSpacingBottom",
    "mdDownSpacing",
    "mdDownSpacingTop",
    "mdDownSpacingLeft",
    "mdDownSpacingRight",
    "mdDownSpacingBottom",
    "lgSpacing",
    "lgSpacingTop",
    "lgSpacingLeft",
    "lgSpacingRight",
    "lgSpacingBottom",
    "xsDirection",
    "mdDirection",
    "mdUpDirection",
    "mdDownDirection",
    "lgDirection",
    "xsAlignItems",
    "mdAlignItems",
    "mdUpAlignItems",
    "mdDownAlignItems",
    "lgAlignItems",
    "xsJustify",
    "mdJustify",
    "mdUpJustify",
    "mdDownJustify",
    "lgJustify",
    "fullWidth"
];
var $cc328f81773e9021$var$_templateObject;
function $cc328f81773e9021$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $cc328f81773e9021$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc328f81773e9021$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc328f81773e9021$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cc328f81773e9021$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc328f81773e9021$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cc328f81773e9021$var$_defineProperty(e, r, t) {
    return (r = $cc328f81773e9021$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $cc328f81773e9021$var$_toPropertyKey(t) {
    var i = $cc328f81773e9021$var$_toPrimitive(t, "string");
    return "symbol" == $cc328f81773e9021$var$_typeof(i) ? i : i + "";
}
function $cc328f81773e9021$var$_toPrimitive(t, r) {
    if ("object" != $cc328f81773e9021$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cc328f81773e9021$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cc328f81773e9021$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $cc328f81773e9021$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $cc328f81773e9021$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $cc328f81773e9021$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $cc328f81773e9021$var$SPACE_MULTIPLIER = 5;
var $cc328f81773e9021$var$spaceInPixels = function spaceInPixels(space) {
    return "".concat((space === true ? 1 : Number(space)) * $cc328f81773e9021$var$SPACE_MULTIPLIER, "px");
};
/**
 * check https://material-ui.com/api/grid/ for Grid props
 * - xs is for xs and higher
 * - md is for md and higher
 * - lg is for lg and higher
 *
 * we have added the following props where we use 3 variants for each breakpoint (md, mdUp, mdDown)
 * - spacing is for all viewports (this is supported by Grid, but we are overriding the default behavior)
 * - xsSpacing is for only xs (mobile)
 * - mdSpacing is for only md (tablet)
 * - mdUpSpacing is for md and higher (tablet and higher)
 * - mdDownSpacing is for md and lower (tablet and lower)
 * - lgSpacing is for only lg (desktop)
 * - the same rules apply for the direction props
 *
 * currently, we don't use sm and xl
 */ var $cc328f81773e9021$var$StyledGrid = $cc328f81773e9021$exports.Grid = (0, $cc328f81773e9021$var$_styledComponents["default"])(function(_ref) {
    var inline = _ref.inline, spacing = _ref.spacing, spacingTop = _ref.spacingTop, spacingLeft = _ref.spacingLeft, spacingRight = _ref.spacingRight, spacingBottom = _ref.spacingBottom, xsSpacing = _ref.xsSpacing, xsSpacingTop = _ref.xsSpacingTop, xsSpacingLeft = _ref.xsSpacingLeft, xsSpacingRight = _ref.xsSpacingRight, xsSpacingBottom = _ref.xsSpacingBottom, mdSpacing = _ref.mdSpacing, mdSpacingTop = _ref.mdSpacingTop, mdSpacingLeft = _ref.mdSpacingLeft, mdSpacingRight = _ref.mdSpacingRight, mdSpacingBottom = _ref.mdSpacingBottom, mdUpSpacing = _ref.mdUpSpacing, mdUpSpacingTop = _ref.mdUpSpacingTop, mdUpSpacingLeft = _ref.mdUpSpacingLeft, mdUpSpacingRight = _ref.mdUpSpacingRight, mdUpSpacingBottom = _ref.mdUpSpacingBottom, mdDownSpacing = _ref.mdDownSpacing, mdDownSpacingTop = _ref.mdDownSpacingTop, mdDownSpacingLeft = _ref.mdDownSpacingLeft, mdDownSpacingRight = _ref.mdDownSpacingRight, mdDownSpacingBottom = _ref.mdDownSpacingBottom, lgSpacing = _ref.lgSpacing, lgSpacingTop = _ref.lgSpacingTop, lgSpacingLeft = _ref.lgSpacingLeft, lgSpacingRight = _ref.lgSpacingRight, lgSpacingBottom = _ref.lgSpacingBottom, xsDirection = _ref.xsDirection, mdDirection = _ref.mdDirection, mdUpDirection = _ref.mdUpDirection, mdDownDirection = _ref.mdDownDirection, lgDirection = _ref.lgDirection, xsAlignItems = _ref.xsAlignItems, mdAlignItems = _ref.mdAlignItems, mdUpAlignItems = _ref.mdUpAlignItems, mdDownAlignItems = _ref.mdDownAlignItems, lgAlignItems = _ref.lgAlignItems, xsJustify = _ref.xsJustify, mdJustify = _ref.mdJustify, mdUpJustify = _ref.mdUpJustify, mdDownJustify = _ref.mdDownJustify, lgJustify = _ref.lgJustify, fullWidth = _ref.fullWidth, rest = $cc328f81773e9021$var$_objectWithoutProperties(_ref, $cc328f81773e9021$var$_excluded);
    return /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($cc328f81773e9021$var$_Grid["default"], $cc328f81773e9021$var$_objectSpread({}, rest));
}).attrs(function() {
    return {
        classes: {
            item: "item",
            container: "container"
        }
    };
})($cc328f81773e9021$var$_templateObject || ($cc328f81773e9021$var$_templateObject = $cc328f81773e9021$var$_taggedTemplateLiteral([
    "\n  ",
    "\n\n  &.container {\n    ",
    "\n    ",
    "\n    ",
    "\n    ",
    "\n    ",
    "\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n\n        ",
    "\n        ",
    "\n        ",
    "\n        ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n  }\n\n  &.item {\n    ",
    "\n\n    ",
    "\n    ",
    "\n    ",
    "\n    ",
    "\n    ",
    "\n    \n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    &:empty {\n      padding: 0;\n    }\n  }\n"
])), function(props) {
    return props.fullWidth && "width: 100%;";
}, function(props) {
    return props.spacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacing), ";");
}, function(props) {
    return props.spacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingTop), ";");
}, function(props) {
    return props.spacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingLeft), ";");
}, function(props) {
    return props.spacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingRight), ";");
}, function(props) {
    return props.spacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingBottom), ";");
}, function(props) {
    return props.theme.query.mobile;
}, function(props) {
    return props.xsSpacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacing), ";");
}, function(props) {
    return props.xsDirection && "flex-direction: ".concat(props.xsDirection, ";");
}, function(props) {
    return props.xsAlignItems && "align-items: ".concat(props.xsAlignItems, ";");
}, function(props) {
    return props.xsJustify && "justify-content: ".concat(props.xsJustify, ";");
}, function(props) {
    return props.xsSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingTop), ";");
}, function(props) {
    return props.xsSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingLeft), ";");
}, function(props) {
    return props.xsSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingRight), ";");
}, function(props) {
    return props.xsSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingBottom), ";");
}, function(props) {
    return props.theme.query.tablet;
}, function(props) {
    return props.mdSpacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacing), ";");
}, function(props) {
    return props.mdDirection && "flex-direction: ".concat(props.mdDirection, ";");
}, function(props) {
    return props.mdAlignItems && "align-items: ".concat(props.mdAlignItems, ";");
}, function(props) {
    return props.mdJustify && "justify-content: ".concat(props.mdJustify, ";");
}, function(props) {
    return props.mdSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingTop), ";");
}, function(props) {
    return props.mdSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingLeft), ";");
}, function(props) {
    return props.mdSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingRight), ";");
}, function(props) {
    return props.mdSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingBottom), ";");
}, function(props) {
    return props.theme.query.max.lg;
}, function(props) {
    return props.mdDownSpacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacing), ";");
}, function(props) {
    return props.mdDownDirection && "flex-direction: ".concat(props.mdDownDirection, ";");
}, function(props) {
    return props.mdDownAlignItems && "align-items: ".concat(props.mdDownAlignItems, ";");
}, function(props) {
    return props.mdDownJustify && "justify-content: ".concat(props.mdDownJustify, ";");
}, function(props) {
    return props.mdDownSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingTop), ";");
}, function(props) {
    return props.mdDownSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingLeft), ";");
}, function(props) {
    return props.mdDownSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingRight), ";");
}, function(props) {
    return props.mdDownSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingBottom), ";");
}, function(props) {
    return props.theme.query.min.md;
}, function(props) {
    return props.mdUpDirection && "flex-direction: ".concat(props.mdUpDirection, ";");
}, function(props) {
    return props.mdUpSpacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacing), ";");
}, function(props) {
    return props.mdUpAlignItems && "align-items: ".concat(props.mdUpAlignItems, ";");
}, function(props) {
    return props.mdUpJustify && "justify-content: ".concat(props.mdUpJustify, ";");
}, function(props) {
    return props.mdUpSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingTop), ";");
}, function(props) {
    return props.mdUpSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingLeft), ";");
}, function(props) {
    return props.mdUpSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingRight), ";");
}, function(props) {
    return props.mdUpSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingBottom), ";");
}, function(props) {
    return props.theme.query.min.lg;
}, function(props) {
    return props.lgSpacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacing), ";");
}, function(props) {
    return props.lgDirection && "flex-direction: ".concat(props.lgDirection, ";");
}, function(props) {
    return props.lgAlignItems && "align-items: ".concat(props.lgAlignItems, ";");
}, function(props) {
    return props.lgJustify && "justify-content: ".concat(props.lgJustify, ";");
}, function(props) {
    return props.lgSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingTop), ";");
}, function(props) {
    return props.lgSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingLeft), ";");
}, function(props) {
    return props.lgSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingRight), ";");
}, function(props) {
    return props.lgSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingBottom), ";");
}, function(props) {
    return props.inline && "display: inline-flex;";
}, function(props) {
    return props.spacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacing), ";");
}, function(props) {
    return props.spacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingTop), ";");
}, function(props) {
    return props.spacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingLeft), ";");
}, function(props) {
    return props.spacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingRight), ";");
}, function(props) {
    return props.spacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingBottom), ";");
}, function(props) {
    return props.theme.query.mobile;
}, function(props) {
    return props.xsSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingTop), ";");
}, function(props) {
    return props.xsSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingLeft), ";");
}, function(props) {
    return props.xsSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingRight), ";");
}, function(props) {
    return props.xsSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingBottom), ";");
}, function(props) {
    return props.theme.query.tablet;
}, function(props) {
    return props.mdSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingTop), ";");
}, function(props) {
    return props.mdSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingLeft), ";");
}, function(props) {
    return props.mdSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingRight), ";");
}, function(props) {
    return props.mdSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingBottom), ";");
}, function(props) {
    return props.theme.query.max.lg;
}, function(props) {
    return props.mdDownSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingTop), ";");
}, function(props) {
    return props.mdDownSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingLeft), ";");
}, function(props) {
    return props.mdDownSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingRight), ";");
}, function(props) {
    return props.mdDownSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingBottom), ";");
}, function(props) {
    return props.theme.query.min.md;
}, function(props) {
    return props.mdUpSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingTop), ";");
}, function(props) {
    return props.mdUpSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingLeft), ";");
}, function(props) {
    return props.mdUpSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingRight), ";");
}, function(props) {
    return props.mdUpSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingBottom), ";");
}, function(props) {
    return props.theme.query.min.lg;
}, function(props) {
    return props.lgSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingTop), ";");
}, function(props) {
    return props.lgSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingLeft), ";");
}, function(props) {
    return props.lgSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingRight), ";");
}, function(props) {
    return props.lgSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingBottom), ";");
});



var $5052ded2deae85fc$var$_react = $5052ded2deae85fc$var$_interopRequireDefault($gcYvX$react);
var $8e4c3c0f3edf40cb$exports = {};
"use strict";
Object.defineProperty($8e4c3c0f3edf40cb$exports, "__esModule", {
    value: true
});
$8e4c3c0f3edf40cb$exports.Wrapper = $8e4c3c0f3edf40cb$exports.LoadingSkeleton = void 0;
var $03f0ecd691d7f703$exports = {};
"use strict";
Object.defineProperty($03f0ecd691d7f703$exports, "__esModule", {
    value: true
});
$03f0ecd691d7f703$exports.LoaderSkeleton = void 0;


var $03f0ecd691d7f703$var$_react = $03f0ecd691d7f703$var$_interopRequireDefault($gcYvX$react);
var $f1ed9d87b4d065fe$exports = {};
"use strict";
Object.defineProperty($f1ed9d87b4d065fe$exports, "__esModule", {
    value: true
});
Object.defineProperty($f1ed9d87b4d065fe$exports, "useWidth", {
    enumerable: true,
    get: function get() {
        return $b287f3a707d8a4a3$exports.useWidth;
    }
});
var $b287f3a707d8a4a3$exports = {};
"use strict";
Object.defineProperty($b287f3a707d8a4a3$exports, "__esModule", {
    value: true
});
$b287f3a707d8a4a3$exports.useWidth = void 0;
var $bb6a8a3022cc23ea$exports = {};
"use strict";
Object.defineProperty($bb6a8a3022cc23ea$exports, "__esModule", {
    value: true
});
$bb6a8a3022cc23ea$exports.viewports = $bb6a8a3022cc23ea$exports.typoSelector = $bb6a8a3022cc23ea$exports.typo = $bb6a8a3022cc23ea$exports.query = $bb6a8a3022cc23ea$exports.layer = $bb6a8a3022cc23ea$exports.gradient = $bb6a8a3022cc23ea$exports.fontWeight = $bb6a8a3022cc23ea$exports.colorSelector = $bb6a8a3022cc23ea$exports.color = $bb6a8a3022cc23ea$exports.breakpoint = $bb6a8a3022cc23ea$exports.boxShadowFocus = $bb6a8a3022cc23ea$exports.boxShadow = $bb6a8a3022cc23ea$exports.border = $bb6a8a3022cc23ea$exports.Theme = void 0;

var $bebaee556f9a4756$exports = {};
"use strict";
Object.defineProperty($bebaee556f9a4756$exports, "__esModule", {
    value: true
});
$bebaee556f9a4756$exports.FONTS = void 0;
var $bebaee556f9a4756$var$FONTS = $bebaee556f9a4756$exports.FONTS = {
    displayXXL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "62px",
        lineHeight: "150%"
    },
    displayXL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "46px",
        lineHeight: "150%"
    },
    displayL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "34px",
        lineHeight: "150%"
    },
    displayM: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "24px",
        lineHeight: "150%"
    },
    displayS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "18px",
        lineHeight: "180%"
    },
    displayXS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "14px",
        lineHeight: "180%"
    },
    displayXXS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "12px",
        lineHeight: "180%"
    },
    bodyL: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "18px",
        lineHeight: "180%"
    },
    bodyM: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "14px",
        lineHeight: "180%"
    },
    bodyS: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "12px",
        lineHeight: "180%"
    },
    bodyXS: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "10px",
        lineHeight: "180%"
    }
};


var $bb6a8a3022cc23ea$var$_templateObject, $bb6a8a3022cc23ea$var$_templateObject2, $bb6a8a3022cc23ea$var$_templateObject3, $bb6a8a3022cc23ea$var$_templateObject4, $bb6a8a3022cc23ea$var$_templateObject5, $bb6a8a3022cc23ea$var$_templateObject6, $bb6a8a3022cc23ea$var$_templateObject7, $bb6a8a3022cc23ea$var$_templateObject8, $bb6a8a3022cc23ea$var$_templateObject9, $bb6a8a3022cc23ea$var$_templateObject10, $bb6a8a3022cc23ea$var$_templateObject11, $bb6a8a3022cc23ea$var$_templateObject12, $bb6a8a3022cc23ea$var$_templateObject13, $bb6a8a3022cc23ea$var$_templateObject14, $bb6a8a3022cc23ea$var$_templateObject15;
function $bb6a8a3022cc23ea$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $bb6a8a3022cc23ea$var$color = $bb6a8a3022cc23ea$exports.color = Object.freeze({
    p100: "#EEF7FF",
    p200: "#9AC7EF",
    p300: "#5AB1FF",
    p400: "#1D71F3",
    p500: "#1A4EC0",
    p600: "#112F86",
    a100: "#FFF6EC",
    a200: "#FFD3A5",
    a300: "#FF8932",
    a400: "#FF670A",
    a500: "#FF4D00",
    a600: "#A12A0B",
    b100: "#F0FDF1",
    b200: "#BAF8C3",
    b300: "#84F195",
    b400: "#47E160",
    b500: "#14B22E",
    b600: "#128325",
    c100: "#FDF1F2",
    c200: "#F7CAD4",
    c300: "#EE96A9",
    c400: "#DD5C75",
    c500: "#BB3853",
    c600: "#881D3F",
    d100: "#F6F4FE",
    d200: "#DFD9FB",
    d300: "#AB92F3",
    d400: "#7638DF",
    d500: "#491896",
    d600: "#30165F",
    g100: "#F6F6F8",
    g200: "#ECEEF2",
    g300: "#AEB8CB",
    g400: "#627495",
    g500: "#404B64",
    g600: "#262E41",
    e100: "#FFF1F1",
    e200: "#FFC7C5",
    e300: "#FF6A65",
    e400: "#ED2C25",
    e500: "#C7140E",
    e600: "#6D0400",
    white: "#FFFFFF",
    black: "#000000",
    facebook: "#4464a0",
    twitter: "#1da1f2",
    linkedin: "#0077b5"
});
var $bb6a8a3022cc23ea$var$colorSelector = $bb6a8a3022cc23ea$exports.colorSelector = function colorSelector(colorKey) {
    return function(props) {
        return props.theme.color[colorKey.toLowerCase()];
    };
};
var $bb6a8a3022cc23ea$var$typo = $bb6a8a3022cc23ea$exports.typo = Object.freeze(Object.keys($bebaee556f9a4756$exports.FONTS).reduce(function(acc, key) {
    acc[key] = (0, $gcYvX$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject || ($bb6a8a3022cc23ea$var$_templateObject = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n      font-size: ",
        ";\n      font-family: ",
        ";\n      line-height: ",
        ";\n    "
    ])), $bebaee556f9a4756$exports.FONTS[key].fontSize, $bebaee556f9a4756$exports.FONTS[key].fontFamily, $bebaee556f9a4756$exports.FONTS[key].lineHeight);
    return acc;
}, {}));
var $bb6a8a3022cc23ea$var$typoSelector = $bb6a8a3022cc23ea$exports.typoSelector = function typoSelector(typoKey) {
    return function(props) {
        return props.theme.typo[typoKey];
    };
};
var $bb6a8a3022cc23ea$var$fontWeight = $bb6a8a3022cc23ea$exports.fontWeight = Object.freeze({
    light: (0, $gcYvX$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject2 || ($bb6a8a3022cc23ea$var$_templateObject2 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 300;\n  "
    ]))),
    regular: (0, $gcYvX$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject3 || ($bb6a8a3022cc23ea$var$_templateObject3 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 400;\n  "
    ]))),
    medium: (0, $gcYvX$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject4 || ($bb6a8a3022cc23ea$var$_templateObject4 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 600;\n  "
    ]))),
    bold: (0, $gcYvX$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject5 || ($bb6a8a3022cc23ea$var$_templateObject5 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 700;\n  "
    ])))
});
var $bb6a8a3022cc23ea$var$boxShadowFocus = $bb6a8a3022cc23ea$exports.boxShadowFocus = (0, $gcYvX$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject6 || ($bb6a8a3022cc23ea$var$_templateObject6 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
    "\n  &:focus {\n    box-shadow: 0px 0px 10px ",
    ";\n  }\n"
])), $bb6a8a3022cc23ea$var$color.d100);
var $bb6a8a3022cc23ea$var$gradient = $bb6a8a3022cc23ea$exports.gradient = Object.freeze({
    lagoon: (0, $gcYvX$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject7 || ($bb6a8a3022cc23ea$var$_templateObject7 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(\n      87.41deg,\n      ",
        " 4.03%,\n      ",
        " 95.69%\n    );\n  "
    ])), $bb6a8a3022cc23ea$var$color.p500, $bb6a8a3022cc23ea$var$color.p600),
    wave: (0, $gcYvX$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject8 || ($bb6a8a3022cc23ea$var$_templateObject8 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(236.19deg, #133599 7.5%, #05164a 86.12%);\n  "
    ]))),
    nector: (0, $gcYvX$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject9 || ($bb6a8a3022cc23ea$var$_templateObject9 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(\n      84.4deg,\n      #e00051 6.75%,\n      ",
        " 97.26%\n    );\n  "
    ])), $bb6a8a3022cc23ea$var$color.a500)
});
var $bb6a8a3022cc23ea$var$boxShadow = $bb6a8a3022cc23ea$exports.boxShadow = Object.freeze({
    level1: (0, $gcYvX$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject10 || ($bb6a8a3022cc23ea$var$_templateObject10 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level2: (0, $gcYvX$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject11 || ($bb6a8a3022cc23ea$var$_templateObject11 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level3: (0, $gcYvX$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject12 || ($bb6a8a3022cc23ea$var$_templateObject12 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level4: (0, $gcYvX$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject13 || ($bb6a8a3022cc23ea$var$_templateObject13 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 14px 28px rgba(0, 0, 0, 0.1);\n  "
    ]))),
    level5: (0, $gcYvX$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject14 || ($bb6a8a3022cc23ea$var$_templateObject14 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 19px 38px rgba(0, 0, 0, 0.15);\n  "
    ]))),
    focus: (0, $gcYvX$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject15 || ($bb6a8a3022cc23ea$var$_templateObject15 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 0px 10px ",
        ";\n  "
    ])), $bb6a8a3022cc23ea$var$color.d100)
});
var $bb6a8a3022cc23ea$var$border = $bb6a8a3022cc23ea$exports.border = Object.freeze({
    level1: "0.3px solid rgba(130, 130, 130, 0.5)"
});
var $bb6a8a3022cc23ea$var$layer = $bb6a8a3022cc23ea$exports.layer = Object.freeze({
    hidden: -1,
    select: 5,
    newQuoteButton: 45,
    navbar: 50,
    tooltip: 60,
    mobileSocialFooter: 70,
    popup: 90,
    modal: 100,
    slideOut: 1101,
    welcomeModal: 1301
});
var $bb6a8a3022cc23ea$var$viewports = $bb6a8a3022cc23ea$exports.viewports = {
    mobile: {
        width: 360,
        breakpoint: "sm"
    },
    tablet: {
        width: 768,
        breakpoint: "md"
    },
    desktop: {
        width: 1200,
        breakpoint: "lg"
    }
};
// https://material-ui.com/customization/default-theme/?expend-path=$.breakpoints.values
var $bb6a8a3022cc23ea$var$breakpoint = $bb6a8a3022cc23ea$exports.breakpoint = Object.freeze({
    // this prop is needed because webapp/imports/styledComponents/Grid/Column.js uses xs viewport
    xs: 0,
    sm: 0,
    md: $bb6a8a3022cc23ea$var$viewports.tablet.width,
    lg: $bb6a8a3022cc23ea$var$viewports.desktop.width
});
// https://getbootstrap.com/docs/4.3/layout/overview/
var $bb6a8a3022cc23ea$var$query = $bb6a8a3022cc23ea$exports.query = {
    min: {
        solve: function solve(width) {
            return "(min-width: ".concat(width, "px)");
        },
        tablet: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md, "px)")
    },
    max: {
        solve: function solve(width) {
            return "(max-width: ".concat(width - 0.02, "px)");
        },
        tablet: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.lg - 0.02, "px)")
    },
    mobile: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px)"),
    tablet: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md, "px) and (max-width: ").concat($bb6a8a3022cc23ea$var$breakpoint.lg - 0.02, "px)"),
    desktop: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.lg, "px)"),
    dpr2x: "(min-resolution: 2dppx), (min-resolution: 192dpi)",
    mobileDpr2x: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px) and (min-resolution: 2dppx), (max-width: ").concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px) and (min-resolution: 192dpi)")
};
Object.keys($bb6a8a3022cc23ea$var$breakpoint).forEach(function(key) {
    $bb6a8a3022cc23ea$var$query.min[key] = $bb6a8a3022cc23ea$var$query.min.solve($bb6a8a3022cc23ea$var$breakpoint[key]);
    $bb6a8a3022cc23ea$var$query.max[key] = $bb6a8a3022cc23ea$var$query.max.solve($bb6a8a3022cc23ea$var$breakpoint[key]);
});
Object.freeze($bb6a8a3022cc23ea$var$query);
Object.freeze($bb6a8a3022cc23ea$var$query.min);
Object.freeze($bb6a8a3022cc23ea$var$query.max);
var $bb6a8a3022cc23ea$var$Theme = $bb6a8a3022cc23ea$exports.Theme = Object.freeze({
    color: $bb6a8a3022cc23ea$var$color,
    typo: $bb6a8a3022cc23ea$var$typo,
    border: $bb6a8a3022cc23ea$var$border,
    boxShadow: $bb6a8a3022cc23ea$var$boxShadow,
    boxShadowFocus: $bb6a8a3022cc23ea$var$boxShadowFocus,
    gradient: $bb6a8a3022cc23ea$var$gradient,
    layer: $bb6a8a3022cc23ea$var$layer,
    fontWeight: $bb6a8a3022cc23ea$var$fontWeight,
    query: $bb6a8a3022cc23ea$var$query
});



var $b287f3a707d8a4a3$var$_useMediaQuery = $b287f3a707d8a4a3$var$_interopRequireDefault($gcYvX$muimaterialuseMediaQuery);
function $b287f3a707d8a4a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $b287f3a707d8a4a3$var$useWidth = $b287f3a707d8a4a3$exports.useWidth = function useWidth() {
    var isDesktop = (0, $b287f3a707d8a4a3$var$_useMediaQuery["default"])($bb6a8a3022cc23ea$exports.Theme.query.desktop);
    var isTablet = (0, $b287f3a707d8a4a3$var$_useMediaQuery["default"])($bb6a8a3022cc23ea$exports.Theme.query.tablet);
    var isMobile = (0, $b287f3a707d8a4a3$var$_useMediaQuery["default"])($bb6a8a3022cc23ea$exports.Theme.query.mobile);
    return {
        isDesktop: isDesktop,
        isTablet: isTablet,
        isMobile: isMobile
    };
};





var $fabe551d7c4b1938$exports = {};
"use strict";
Object.defineProperty($fabe551d7c4b1938$exports, "__esModule", {
    value: true
});
$fabe551d7c4b1938$exports.SingleRateSkeletonWrapper = $fabe551d7c4b1938$exports.EmptyPlaceholder = void 0;
var $11940384c25e2dec$exports = {};
"use strict";
Object.defineProperty($11940384c25e2dec$exports, "__esModule", {
    value: true
});
$11940384c25e2dec$exports.Box = void 0;

var $11940384c25e2dec$var$_styledComponents = $11940384c25e2dec$var$_interopRequireDefault($gcYvX$styledcomponents);
var $11940384c25e2dec$var$_templateObject;
function $11940384c25e2dec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $11940384c25e2dec$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $11940384c25e2dec$var$Box = $11940384c25e2dec$exports.Box = $11940384c25e2dec$var$_styledComponents["default"].div($11940384c25e2dec$var$_templateObject || ($11940384c25e2dec$var$_templateObject = $11940384c25e2dec$var$_taggedTemplateLiteral([
    "\n  background-color: ",
    ";\n  padding: 15px;\n  ",
    ";\n  border-radius: 4px;\n\n  &:hover {\n    ",
    ";\n  }\n"
])), function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.boxShadow.level1;
}, function(props) {
    return props.theme.boxShadow.level2;
});



var $fabe551d7c4b1938$var$_styledComponents2 = $fabe551d7c4b1938$var$_interopRequireDefault($gcYvX$styledcomponents);
var $fabe551d7c4b1938$var$_templateObject, $fabe551d7c4b1938$var$_templateObject2;
function $fabe551d7c4b1938$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $fabe551d7c4b1938$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $fabe551d7c4b1938$var$SingleRateSkeletonWrapper = $fabe551d7c4b1938$exports.SingleRateSkeletonWrapper = (0, $fabe551d7c4b1938$var$_styledComponents2["default"])($11940384c25e2dec$exports.Box)($fabe551d7c4b1938$var$_templateObject || ($fabe551d7c4b1938$var$_templateObject = $fabe551d7c4b1938$var$_taggedTemplateLiteral([
    "\n  padding: 20px;\n  @media ",
    " {\n    padding: 20px 15px;\n  }\n"
])), function(props) {
    return props.theme.query.mobile;
});
var $fabe551d7c4b1938$var$EmptyPlaceholder = $fabe551d7c4b1938$exports.EmptyPlaceholder = $fabe551d7c4b1938$var$_styledComponents2["default"].div($fabe551d7c4b1938$var$_templateObject2 || ($fabe551d7c4b1938$var$_templateObject2 = $fabe551d7c4b1938$var$_taggedTemplateLiteral([
    "\n  height: 16px;\n  margin-bottom: 12px;\n"
])));



var $03f0ecd691d7f703$var$_Skeleton, $03f0ecd691d7f703$var$_Grid, $03f0ecd691d7f703$var$_Grid2, $03f0ecd691d7f703$var$_Grid3, $03f0ecd691d7f703$var$_Grid4, $03f0ecd691d7f703$var$_Grid5, $03f0ecd691d7f703$var$_Grid6, $03f0ecd691d7f703$var$_Grid7;
function $03f0ecd691d7f703$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $03f0ecd691d7f703$var$SkeletonItem = function SkeletonItem(props) {
    return /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
        item: true,
        xs: props.size,
        children: $03f0ecd691d7f703$var$_Skeleton || ($03f0ecd691d7f703$var$_Skeleton = /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($gcYvX$muimaterial.Skeleton, {}))
    });
};
var $03f0ecd691d7f703$var$DesktopBottomItem = function DesktopBottomItem() {
    return $03f0ecd691d7f703$var$_Grid || ($03f0ecd691d7f703$var$_Grid = /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
        item: true,
        xs: 3,
        children: /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
            container: true,
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($03f0ecd691d7f703$var$SkeletonItem, {
                    size: 5
                }),
                /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($03f0ecd691d7f703$var$SkeletonItem, {
                    size: 5
                })
            ]
        })
    }));
};
var $03f0ecd691d7f703$var$LoaderSkeleton = $03f0ecd691d7f703$exports.LoaderSkeleton = function LoaderSkeleton(props) {
    var _props$showMobileView = props.showMobileView, showMobileView = _props$showMobileView === void 0 ? false : _props$showMobileView, className = props.className;
    var _useWidth = (0, $f1ed9d87b4d065fe$exports.useWidth)(), isMobile = _useWidth.isMobile;
    if (isMobile || showMobileView) return /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsxs)($fabe551d7c4b1938$exports.SingleRateSkeletonWrapper, {
        "data-testid": "LoaderSkeleton",
        className: className,
        children: [
            $03f0ecd691d7f703$var$_Grid2 || ($03f0ecd691d7f703$var$_Grid2 = /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
                container: true,
                children: /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                    item: true,
                    xs: 8,
                    children: [
                        /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
                            container: true,
                            children: /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($03f0ecd691d7f703$var$SkeletonItem, {
                                size: 12
                            })
                        }),
                        /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                            container: true,
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($03f0ecd691d7f703$var$SkeletonItem, {
                                    size: 4
                                }),
                                /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($03f0ecd691d7f703$var$SkeletonItem, {
                                    size: 4
                                })
                            ]
                        })
                    ]
                })
            })),
            $03f0ecd691d7f703$var$_Grid3 || ($03f0ecd691d7f703$var$_Grid3 = /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                container: true,
                spacingTop: 5,
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                        item: true,
                        xs: 5,
                        children: [
                            /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($gcYvX$muimaterial.Skeleton, {}),
                            /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($gcYvX$muimaterial.Skeleton, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                        item: true,
                        xs: 5,
                        children: [
                            /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($gcYvX$muimaterial.Skeleton, {}),
                            /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($gcYvX$muimaterial.Skeleton, {})
                        ]
                    })
                ]
            })),
            $03f0ecd691d7f703$var$_Grid4 || ($03f0ecd691d7f703$var$_Grid4 = /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                container: true,
                spacingTop: 5,
                children: [
                    /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
                        item: true,
                        xs: 6
                    }),
                    /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($03f0ecd691d7f703$var$SkeletonItem, {
                        size: 6
                    })
                ]
            })),
            $03f0ecd691d7f703$var$_Grid5 || ($03f0ecd691d7f703$var$_Grid5 = /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                container: true,
                spacingTop: 5,
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($03f0ecd691d7f703$var$SkeletonItem, {
                        size: 5
                    }),
                    /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($03f0ecd691d7f703$var$SkeletonItem, {
                        size: 5
                    })
                ]
            }))
        ]
    });
    return /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsxs)($fabe551d7c4b1938$exports.SingleRateSkeletonWrapper, {
        "data-testid": "LoaderSkeleton",
        className: className,
        children: [
            $03f0ecd691d7f703$var$_Grid6 || ($03f0ecd691d7f703$var$_Grid6 = /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                container: true,
                children: [
                    /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                        item: true,
                        spacingRight: 40,
                        xs: 6,
                        children: [
                            /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
                                container: true,
                                children: /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($03f0ecd691d7f703$var$SkeletonItem, {
                                    size: 12
                                })
                            }),
                            /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                                container: true,
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($03f0ecd691d7f703$var$SkeletonItem, {
                                        size: 4
                                    }),
                                    /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($03f0ecd691d7f703$var$SkeletonItem, {
                                        size: 4
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                        item: true,
                        spacingRight: 20,
                        xs: 3,
                        children: [
                            /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
                                container: true,
                                children: /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($03f0ecd691d7f703$var$SkeletonItem, {
                                    size: 12
                                })
                            }),
                            /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
                                container: true,
                                children: /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($03f0ecd691d7f703$var$SkeletonItem, {
                                    size: 12
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                        item: true,
                        spacingLeft: 20,
                        xs: 3,
                        children: [
                            /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
                                container: true,
                                children: /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($fabe551d7c4b1938$exports.EmptyPlaceholder, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
                                container: true,
                                children: /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($03f0ecd691d7f703$var$SkeletonItem, {
                                    size: 12
                                })
                            })
                        ]
                    })
                ]
            })),
            $03f0ecd691d7f703$var$_Grid7 || ($03f0ecd691d7f703$var$_Grid7 = /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                container: true,
                spacingTop: 10,
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($03f0ecd691d7f703$var$DesktopBottomItem, {}),
                    /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($03f0ecd691d7f703$var$DesktopBottomItem, {})
                ]
            }))
        ]
    });
};



var $8e4c3c0f3edf40cb$var$_styledComponents = $8e4c3c0f3edf40cb$var$_interopRequireDefault($gcYvX$styledcomponents);
var $8e4c3c0f3edf40cb$var$_templateObject, $8e4c3c0f3edf40cb$var$_templateObject2;
function $8e4c3c0f3edf40cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $8e4c3c0f3edf40cb$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $8e4c3c0f3edf40cb$var$LoadingSkeleton = $8e4c3c0f3edf40cb$exports.LoadingSkeleton = (0, $8e4c3c0f3edf40cb$var$_styledComponents["default"])($03f0ecd691d7f703$exports.LoaderSkeleton)($8e4c3c0f3edf40cb$var$_templateObject || ($8e4c3c0f3edf40cb$var$_templateObject = $8e4c3c0f3edf40cb$var$_taggedTemplateLiteral([
    "\n  margin-bottom: 20px;\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n"
])));
var $8e4c3c0f3edf40cb$var$Wrapper = $8e4c3c0f3edf40cb$exports.Wrapper = $8e4c3c0f3edf40cb$var$_styledComponents["default"].div($8e4c3c0f3edf40cb$var$_templateObject2 || ($8e4c3c0f3edf40cb$var$_templateObject2 = $8e4c3c0f3edf40cb$var$_taggedTemplateLiteral([
    "\n  background: ",
    ";\n"
])), function(props) {
    return props.theme.color.g100;
});



function $5052ded2deae85fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $5052ded2deae85fc$var$_toConsumableArray(r) {
    return $5052ded2deae85fc$var$_arrayWithoutHoles(r) || $5052ded2deae85fc$var$_iterableToArray(r) || $5052ded2deae85fc$var$_unsupportedIterableToArray(r) || $5052ded2deae85fc$var$_nonIterableSpread();
}
function $5052ded2deae85fc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5052ded2deae85fc$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5052ded2deae85fc$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5052ded2deae85fc$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5052ded2deae85fc$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $5052ded2deae85fc$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $5052ded2deae85fc$var$_arrayLikeToArray(r);
}
function $5052ded2deae85fc$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $5052ded2deae85fc$var$DEFAULT_LOADING_CARD_COUNT = 3;
var $5052ded2deae85fc$var$Loader = $5052ded2deae85fc$exports.Loader = function Loader(_ref) {
    var spacing = _ref.spacing, _ref$showMobileView = _ref.showMobileView, showMobileView = _ref$showMobileView === void 0 ? false : _ref$showMobileView, _ref$cardCount = _ref.cardCount, cardCount = _ref$cardCount === void 0 ? $5052ded2deae85fc$var$DEFAULT_LOADING_CARD_COUNT : _ref$cardCount, className = _ref.className;
    return /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($8e4c3c0f3edf40cb$exports.Wrapper, {
        className: className,
        children: /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
            container: true,
            spacing: spacing,
            children: /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
                item: true,
                xs: 12,
                children: $5052ded2deae85fc$var$_toConsumableArray(Array(cardCount).keys()).map(function(i) {
                    return /*#__PURE__*/ (0, $gcYvX$reactjsxruntime.jsx)($8e4c3c0f3edf40cb$exports.LoadingSkeleton, {
                        showMobileView: showMobileView
                    }, i);
                })
            })
        })
    });
};




//# sourceMappingURL=index.js.map
